<template>
    <div>
        <ul>
            <li><strong>Support</strong>: {{ account.support_type }}
                <protokol-tooltip :id="`support-${account.type}`" variant="warning"> 
                    <template #icon>!</template>
                    <template #content>
                        {{ $t(account.supportDescription()) }}
                    </template>
                </protokol-tooltip>
            </li>
            <li><strong>Components</strong> x {{ account.components }}</li>
            <li><strong>Records per Component</strong> x {{ account.component_size }}</li>
            <li><strong>Public apps</strong> <span v-if="account.public_apps < 99999"> x {{ account.public_apps }}</span> <span v-else> unlimited </span> </li>
            <li><strong>Platform apps</strong> <span v-if="account.platform_apps < 99999"> x {{ account.platform_apps }}</span> <span v-else> unlimited </span> </li>
            <li><strong>Sparks</strong> <span v-if="account.sparks < 99999"> x {{ account.sparks }}</span> <span v-else> unlimited </span></li>
            <li><strong>Workspaces</strong> <span v-if="account.workspaces < 9999"> x {{ account.workspaces }}</span> <span v-else> unlimited </span></li>
            <li v-if="account.event_bus"><strong> Event bus </strong>
                <protokol-tooltip id="eventBusDesc" variant="warning"> 
                    <template #icon>!</template>
                    <template #content>
                        Leverage event bus framework and communicate in real-time between platform apps, components and workflows.
                    </template>
                </protokol-tooltip>
            </li>
        </ul>

        <template v-if="prices">
            <template v-if="account.pay_as_you_go">
                <h4>Pay as you go </h4>
                <small>{{$t('billedMonthly')}}</small> 
                <ul style="font-size: 12px;">
                    <li>Every {{ prices.component_size_multiplier }} records in Component is {{ prices.component_multiplier_price / 100 }} {{ currency }}</li>
                    <li>Every new Platform app <span v-if="account.base_platform_apps > 0">after {{ account.base_platform_apps }} </span> is {{ prices.platform_app_price / 100 }} {{ currency }}</li>
                    <li>Every new Public app <span v-if="account.base_public_apps > 0"> after {{ account.base_public_apps }} </span> is {{ prices.public_app_price / 100 }} {{ currency }}</li>
                    <li>Every new workspace after {{ account.base_workspaces }} is {{ prices.workspace_price / 100 }} {{ currency }}</li>
                    <li>Spark per operating second is {{ prices.spark_price / 100000 }} {{ currency }}
                        <protokol-tooltip id="sparkDesc" variant="warning">
                            <template #icon>!</template>
                            <template #content>
                                Operating seconds are calculated based on the total time a function spends executing. If a function has an average execution time of 200ms, invoking it five times would amount to one operating second.
                            </template>
                        </protokol-tooltip>
                    </li>
                </ul>
            </template>
        </template>
    </div>
</template>

<style scoped>
ul {
    padding: 10px;
    margin: 0;
}

ul > li {
    padding: 0;
    margin: 0;
}
</style>

<script>
export default {
    props: {
        account: {
            type: Object
        },

        prices: {
            type: Object
        },

        currency: {
            type: String
        }
    },

    methods: {
        getRates() {
            return this.$store.getters.getCurrencyRates
        }
    },

    mounted() {
        this.$store.dispatch("fetchCurrencyRates")
    }
}
</script>